module.exports = __webpack_public_path__ + "static/media/C2.9e5d5780.png";